/*** IMPORTS FROM imports-loader ***/
var $ = require("jquery");
var jQuery = require("jquery");

export default function capitalize(string) {
  return "" + string.charAt(0).toUpperCase() + string.slice(1);
}



//////////////////
// WEBPACK FOOTER
// ./~/react-bootstrap/es/utils/capitalize.js
// module id = 512
// module chunks = 60